/**
 * Entrée dans l'application. L'identité est tenue par Keycloak, pas ici.
 *
 * Cet écran demandait un identifiant ET un mot de passe, puis les jetait : il redirigeait vers
 * Keycloak, qui les redemandait. Deux torts, dont un sérieux. Le premier est qu'on faisait
 * saisir deux fois la même chose. Le second est qu'on apprenait aux gens à taper leur mot de
 * passe dans un formulaire qui n'est pas celui du fournisseur d'identité — exactement le geste
 * qu'une page de hameçonnage attend d'eux.
 *
 * Il ne reste donc qu'un bouton. Le mot de passe ne se saisit que sur `auth.infranetgn.com`,
 * et nulle part ailleurs.
 */
import { useState } from "react";
import { login } from "@/api/client";

export default function LoginPage({ onLogin }: { onLogin: () => void }) {
  const [error, setError] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  const seConnecter = async () => {
    setEnCours(true);
    setError(null);
    try {
      // Part vers Keycloak et ne revient pas : le navigateur quitte la page. `onLogin` n'est
      // atteint que si la redirection n'a pas eu lieu, c'est-à-dire en cas de panne.
      await login();
      onLogin();
    } catch {
      setError(
        "Le service d'identité est injoignable. Réessayer dans un instant ; si cela persiste, " +
          "prévenir l'administrateur.",
      );
      setEnCours(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-card">
        <img
          src="/marque/logo/infranet-gn-principal.svg"
          alt="InfraNet GN"
          className="login-logo"
          width="220"
          height="64"
        />
        <p className="login-intro">
          Référentiel de l'infrastructure réseau. L'accès est personnel et journalisé.
        </p>
        {error && (
          <p className="login-error" role="alert">
            {error}
          </p>
        )}
        <button
          type="button"
          onClick={seConnecter}
          disabled={enCours}
          className="terrain-button login-submit"
        >
          {enCours ? "Redirection…" : "Se connecter"}
        </button>
        <p className="login-note">
          La connexion se fait sur <strong>auth.infranetgn.com</strong>. Ne saisissez jamais
          votre mot de passe ailleurs.
        </p>
      </div>
    </main>
  );
}
